import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { Card, Spinner } from '../../components/ui';
import { api } from '../../lib/api';
import { formatDateTime } from '../../lib/formatters';

export function EventDetail() {
  const { slug, eventId } = useParams<{ slug: string; eventId: string }>();
  const { data, isLoading } = useQuery({
    queryKey: ['publicEvent', slug, eventId],
    queryFn: async () => (await api.get(`/public/${slug}/events/${eventId}`)).data,
    enabled: !!slug && !!eventId,
  });

  if (isLoading) return <Spinner />;
  if (!data) return <div className="p-6">Not found.</div>;

  return (
    <div className="min-h-screen bg-cream-100 px-6 py-10">
      <div className="max-w-2xl mx-auto space-y-4">
        <h1 className="font-display text-3xl">{data.event.title}</h1>
        <Card className="p-5 space-y-2">
          <div>
            <span className="text-ink-muted">When:</span> {formatDateTime(data.event.startTime)}
          </div>
          {data.event.location && (
            <div>
              <span className="text-ink-muted">Where:</span> {data.event.location}
            </div>
          )}
          {data.event.seatsRemaining !== null && (
            <div>
              <span className="text-ink-muted">Seats remaining:</span> {data.event.seatsRemaining}
            </div>
          )}
        </Card>
        {/* TODO(section-5): registration form with TCPA consent */}
      </div>
    </div>
  );
}
